module.exports = {
	"nl_NL": {
		"ui.about.title.overview": "Nieuwe humanitaire kaarten",
		"ui.about.subhead": "Bijgewerkte humanitaire kaarten voor GIS-analyses of om in GPS-apparaten en smartphones te gebruiken.",
		"ui.about.overview": "Dit platform stelt u in staat om aangepaste exporttaken uit OpenStreetMap (OSM) te maken voor verscheidene regio's van HOT. U kunt een interessegebied specificeren en een lijst met tags voor objecten van OSM voor de export. Er zijn een aantal bestandsindelingen beschikbaar om de gegevens in te exporteren, waaronder ESRI SHP, Garmin IMG, Google KMZ, OSM PBF en SQlite SQL. De beschikbare gegevens van OSM data vanuit de Export Tool wordne bijgewerkt met intervallen van één minuut.",
		"ui.about.title.getting_started": "Hoe te beginnen",
		"ui.about.getting_started": "",
		"ui.exports": "Exporttaken",
		"ui.exports.title": "Exporttaken",
		"ui.help": "Help",
		"ui.login": "Inloggen",
		"ui.about.license": "",
		"ui.about.license.odbl": "ODbL 1.0 gelicenseerd",
		"ui.aoi_toolbar.tools": "",
		"ui.draw.box": "",
		"ui.draw.draw": "",
		"ui.draw.import": "",
		"ui.draw.current_view": "",
		"ui.authorized.thank_you": "",
		"configuration.description.label": "Beschrijving",
		"ui.configuration.description.label": "Beschrijving",
		"export.description.label": "Beschrijving",
		"exports.description.label": "Beschrijving",
		"configuration.description.placeholder": "",
		"configuration.feature_selection.label": "",
		"configuration.name.label": "Naam",
		"ui.configuration.name.label": "Naam",
		"export.name.label": "Naam",
		"exports.name.label": "Naam",
		"configuration.name.placeholder": "",
		"configuration.public.description": "",
		"ui.configuration.update": "",
		"ui.configuration.create": "",
		"ui.configuration.delete": "",
		"ui.configuration.title": "",
		"configuration.title": "",
		"ui.configurations": "",
		"ui.configuration.tables.label": "",
		"ui.configuration.owner.label": "Eigenaar",
		"exports.owner.label": "Eigenaar",
		"export.project.label": "Project",
		"exports.project.label": "Project",
		"export.area.label": "",
		"export.area": "",
		"export.created_at.label": "",
		"export.created_by.label": "",
		"export.published.label": "Gepubliceerd",
		"yes": "",
		"no": "",
		"export.export_formats.label": "",
		"export.osma.label": "",
		"ui.view_this_area": "",
		"ui.exports.status": "",
		"ui.exports.started": "",
		"ui.exports.finished": "",
		"ui.exports.duration": "",
		"ui.exports.features": "Objecten",
		"ui.exports.rerun_export": "",
		"ui.exports.clone_export": "Export klonen",
		"ui.exports.feature_selection.title": "Objecten selecteren",
		"export.feature_selection.label": "Objecten selecteren",
		"ui.close": "Sluiten",
		"export.errors.the_geom.too_large": "",
		"export.buffer_aoi.description": "",
		"export.name.placeholder": "",
		"export.project.placeholder": "",
		"export.published.description": "",
		"export.tag_tree_search.placeholder": "",
		"nav.next": "",
		"export.feature_selection.load_from_josm_preset": "",
		"ui.clear": "",
		"configuration.load_yaml": "",
		"ui.exports.tag_tree": "",
		"ui.exports.stored_configuration": "",
		"ui.exports.create_export": "Export maken",
		"ui.exports.describe_export": "Export beschrijven",
		"ui.exports.choose_formats": "",
		"ui.exports.select_features": "",
		"ui.exports.summary": "",
		"ui.overpass_last_updated": "",
		"ui.show_on_map": "",
		"exports.created.label": "Gemaakt",
		"ui.settings": "",
		"ui.never": "",
		"exports.schedule.6hrs": "",
		"exports.schedule.daily": "",
		"exports.schedule.weekly": "",
		"exports.schedule.monthly": "",
		"ui.unknown": "",
		"ui.untitled": "",
		"runs.last_run.label": "",
		"runs.next_run.label": "",
		"runs.schedule.label": "",
		"ui.private": "Privé",
		"ui.search.only_mine": "",
		"ui.search.placeholder": "",
		"ui.search": "Zoeken",
		"ui.login_to_osm": "Bij OpenStreetMap inloggen",
		"ui.hot.title": "Humanitarian OpenStreetMap Team",
		"ui.toggle_navigation": "",
		"ui.osm_export_tool.title": "OSM Export Tool",
		"ui.create": "Maken",
		"ui.hdx": "",
		"ui.about": "Over",
		"ui.log_out": "Uitloggen",
		"ui.log_in": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/i18n/locales/nl_NL.json
// module id = 1496
// module chunks = 1